const frontendServerUrls = {
  local: 'https://qa.hoursplus.castandcrew.com',
  qa: 'https://qa.hoursplus.castandcrew.com',
  uat: 'https://stg.hoursplus.castandcrew.com',
  aut: 'https://stg.hoursplus.castandcrew.com',
  demo: 'https://demo.hoursplus.castandcrew.com',
  extuat: 'https://ext-uat.hoursplus.castandcrew.com',
  prod: 'https://hoursplus.castandcrew.com',
};

const getHoursPlusUrl = () => {
  const currentEnv = process.env.REACT_APP_ENVIRONMENT || 'prod';
  return frontendServerUrls[currentEnv];
};

export { getHoursPlusUrl };
